import { extend } from 'lodash-es';

export default class Collapsible {

	/**
	 * Generates a collapsable container
	 * @param options ({})
	 */
	constructor (options) {
		this.headerText = '';
		this.closed = false;
		this.content = {};
		this.icoCollapseOnly = false;
		this.iconCollapse = '';
		this.iconExpand = '';

		extend(this, options);

		this.createCollapsible();
		this.setup();
	}

	/**
	 * Creates the collapsible container
	 */
	createCollapsible () {
		this.collapsible = document.createElement('div');
		this.collapsible.className = 'mega-collapsible';

		this.head = document.createElement('div');
		this.head.classList.add('head');

		this.header = document.createElement('h2');
		this.header.appendChild(document.createTextNode(this.headerText));

		this.bodyHead = document.createElement('div');
		this.bodyHead.classList.add('body');

		this.body = document.createElement('div');
		this.body.classList.add('body');

		this.head.appendChild(this.header);
		this.collapsible.appendChild(this.head);
		this.collapsible.appendChild(this.bodyHead);
		this.body.appendChild(this.content);
		this.bodyHead.appendChild(this.body);
		this.collapsible.appendChild(this.bodyHead);
	}

	/**
	 * Creates the collapse image and defines the style
	 * Side note: implement SVG version
	 * @param collapsed
	 */
	collapseImg (collapsed) {
		if (!this.img) {
			this.img = document.createElement('img');
		}

		if (collapsed) {
			this.img.src = this.iconExpand;
			this.img.alt = '[+]';
		} else {
			this.img.src = this.iconCollapse;
			this.img.alt = '[-]';
		}
	}

	/**
	 * Toggles the expansion image
	 */
	handleExpand () {
		if (this.body.style.display !== 'none'){
			this.collapseImg(true);
			this.body.style.display = 'none';
		} else {
			this.collapseImg(false);
			this.body.style.display = 'block';
		}
	}

	/**
	 * Sets up the default collapse behaviour and applies the appropriate events
	 * Creates an action container if one doesn't exist already
	 */
	setup () {
		if (this.closed){
			this.body.style.display = 'none';
		}

		let divs = this.head.getElementsByTagName('div');

		let actionContainer = document.createElement('div');
		actionContainer.classList.add('action-container');

		let actions = (divs.length > 0) ? divs[0] : actionContainer;

		this.collapseImg(this.closed);

		actions.appendChild(this.img);

		if (divs.length === 0){
			this.head.appendChild(actions);
		}

		if (!this.icoCollapseOnly) {
			this.head.addEventListener('click', this.handleExpand.bind(this), false);
		} else {
			this.img.addEventListener('click', this.handleExpand.bind(this), false);
		}
	}

}
